import { ScheduleType } from "./enums/scheduletype";
import { Job, MasterTask, PlanOption, ScheduleTaskChecklist } from "./index";

export class ScheduleTask {
    id: number;
    jobId: number;
    job: Job;
    startDay: number;
    masterTaskId: number;
    masterTaskName: string;
    duration: number;
    floatDays: number;
    paymentTrigger: number;
    locked: boolean;
    baselineDate: Date;
    scheduledStartDate: Date;
    scheduledCompletionDate: Date;
    enteredMultiDayStartDate: Date;
    enteredCompletionDate: Date;
    actualCompletionUTCDate: Date;
    enteredMultiDayPaymentTriggerDate: Date;
    hasChecklist: boolean;
    checklistApproved: boolean;
    checklistApprovedUTCDate: Date;
    accountCategoryId: number;
    accountCategoryName: string;
    daysBehind: number;
    masterTask: MasterTask;
    scheduleType: ScheduleType;
    planOptions: PlanOption[];
    scarStage: string;
    hasRecordables: boolean;
    hasNotes: boolean;
    isUncomplete?: boolean = false;
    sentForPaymentDate?: string;
    recordablesStatus?: number;
    checklist: ScheduleTaskChecklist[];
    isRestricted: boolean = false;
    isHoldPayment?: boolean = false;
    isHoldPaymentEdited?: boolean = false;
    canUndoSentForPayment: boolean = false;
}